import script from "./AgentMessageField.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentMessageField.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__